import React from 'react';
import S from './styles';
import dummy from '../../resources/icon.jpg';
import c_hyun from '../../resources/c_hyun.jpg';
import c_kuu from '../../resources/c_kuu.jpg';
import c_mingso from '../../resources/c_mingso.png';
import c_sean from '../../resources/c_sean.jpg';
import c_teo from '../../resources/c_teo.jpg';
import c_unchain from '../../resources/c_unchain.png';
import c_ssu from '../../resources/c_ssu.jpg';
import c_miiii from '../../resources/c_miiii.jpeg';  
import c_yagom from '../../resources/ya.png';   
import c_jer from '../../resources/c_jer.png';   
import c_zzbae from '../../resources/c_zzbae.jpg'; 
import c_tom from '../../resources/c_tom.png'; 



import { CommitteeItem } from "../committee-item"

const committeeList = [
  {
    name: '재르시',
    company: '',
    profile: c_jer,
    summary: '3대 500 (진)',
    link: 'https://jercy.dev/',
    git: 'https://github.com/JeaSungLEE',
  },
  {
    name: '쿠우',
    company: '',
    profile: c_kuu,
    summary: '렛어스고에 대한 많은 관심과 사랑 감사합니다',
    email: 'developer.kuu@gmail.com'
  },
  {
    name: '야곰',
    company: '',
    profile: c_yagom,
    summary: '디지털보다 아날로그를 사랑하는 프로그래머입니다',
    link: 'yagom-academy.kr',
    git: 'https://github.com/yagom'
  },
  {
    name: '밍소',
    company: '영상촬영/편집',
    profile: c_mingso,
    summary: '와식 코딩법을 찾고 있습니다.',
    email: 'ryu_wol__@naver.com',
    git: 'https://github.com/mingso'
  },
  {
    name: '현이',
    company: '기획',
    profile: c_hyun,
    summary: '기쁘다 애플페이 오셨네',
    email: 'seo_hyeon418@naver.com',
    git: 'https://github.com/seohyeon2'
  },
  {
    name: '언체인',
    company: '기획',
    profile: c_unchain,
    summary: '즐거운 let us Go! 행사가 되도록 노력하겠습니다',
    git: 'https://github.com/unchain123',
    email: 'nchain123@kakao.com'
  },
  {
    name: '톰',
    company: '디자인',
    profile: c_tom,
    summary: '오래오래 일하게 해주세요.',
    email: 'perudot@gmail.com',
    git: 'https://github.com/solchan87'
  },
  {
    name: '써비',
    company: '디자인',
    profile: c_ssu,
    summary: '적당한 고통은 희열이다.',
    email: 'hongssup0202@gmail.com',
    git: 'https://github.com/hongssup'
  },
  {
    name: 'Teo',
    company: '개발',
    profile: c_teo,
    summary: '렛어스고 가보자고',
    email: 'nous178@naver.com',
    git: 'https://github.com/taeuk178'
  },
  {
    name: '재재',
    company: '개발',
    profile: c_zzbae,
    summary: '벽타기 시작한 개발자입니다 🧗🏻‍♀️',
    email: 'jebyun2@gmail.com',
    git: 'https://github.com/ZZBAE'
  },
  {
    name: 'miiii',
    company: '고급잡부',
    profile: c_miiii,
    summary: '프론트 풀스택 인턴입니다',
    email: 'alsgml022100@naver.com',
    git: 'https://github.com/minneee'
  },
  {
    name: 'Sean (션)',
    company: '고급잡부',
    profile: c_sean,
    summary: '발로 뛰는 개발자',
    email: 'ksg3452@gmail.com',
    git: 'https://github.com/SEAN-59'
  },
]

export const Committees = () => (
  <S.Section>
    <S.Title
      id='committees'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      Committees
    </S.Title>
    <S.Wrap>
      { committeeList.map((committe, index) => (<CommitteeItem committe={committe} index={index} key={committe.name} />))}
    </S.Wrap>

  </S.Section>
)
